// extracted by mini-css-extract-plugin
module.exports = {"article-containers":"article-containers--4opkk","article-background-gradient":"article-background-gradient--4opkk"};